"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareProperties = void 0;
const Errors = __importStar(require("../errors"));
const Exps = __importStar(require("../exp"));
const infer_1 = require("../infer");
const Values = __importStar(require("../value"));
function prepareProperties(mod, ctx, properties) {
    const found = new Set();
    const record = {};
    for (const property of properties) {
        for (const [name, exp] of prepareProperty(mod, ctx, property)) {
            if (found.has(name)) {
                throw new Errors.ElaborationError(`duplicate properties: ${name}`, {});
            }
            record[name] = exp;
            found.add(name);
        }
    }
    return record;
}
exports.prepareProperties = prepareProperties;
function prepareProperty(mod, ctx, property) {
    switch (property["@kind"]) {
        case "PropertyPlain": {
            return [[property.name, property.exp]];
        }
        case "PropertySpread": {
            /**
               Type directed spread
            **/
            const inferred = (0, infer_1.infer)(mod, ctx, property.exp);
            Values.assertClazzInCtx(mod, ctx, inferred.type);
            const names = Values.clazzPropertyNames(inferred.type);
            return names.map((name) => [name, Exps.Dot(property.exp, name)]);
        }
    }
}
//# sourceMappingURL=prepareProperties.js.map